export default __webpack_public_path__ + "static/media/14.dba3dd4a.png";